import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/977KnecnJCXUMTWr8Ho0/locations/TnFHd3Ioc8n8XFT8nCpc`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="90%"
                  maxWidth="300px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/977KnecnJCXUMTWr8Ho0/locations/TnFHd3Ioc8n8XFT8nCpc`}
            >
              <CFView hover w="90%">
                <CFImage src={orderPickupButton} maxWidth="280px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
